import { FormControl } from '@angular/forms';

export const NOT_AVAILABLE: number = 999;
export const ASSESSMENTS_COMPLETED_PARENT_REQUEST_DELAY: number = 1;
export const ASSESSMENTS_COMPLETED_NON_PARENT_REQUEST_DELAY: number = 2;
export const PARENT_REQUEST_TO_DELAY: number = 3;
export const PARENTS_WITHDREW_REFERRAL: number = 4;
export const STUDENT_MOVED: number = 5;
export const STUDENT_DIED: number = 6;
export const DELAYS_CONTACTING_PARENTS: number = 7;
export const PARENTS_CANCELLED_EVAL: number = 8;
export const PARENTS_REFUSED_AVAILABILITY: number = 9;
export const STUDENT_HEALTH_UNAVAILABILITY: number = 10;
export const EVAL_TIMELINE_EXTENSION_AGREEMENT: number = 11;
export const EVAL_TIMELINE_BEGAN_EXTENSION_AGREEMENT: number = 12;
export const BILINGUAL_EVALUATOR_UNAVAILABLE: number = 13;
export const TRANSLATION_UNAVAILABLE: number = 14;
export const DELAY_SECURING_EVALUATOR: number = 15;
export const ADDITIONAL_ASSESSMENTS_DOE: number = 16;
export const EVALUATOR_SCHEDULING_DELAY: number = 17;
export const EI_EXCLUDED_REASON_IDS: number[] = [
  NOT_AVAILABLE,
  EVAL_TIMELINE_EXTENSION_AGREEMENT,
  EVAL_TIMELINE_BEGAN_EXTENSION_AGREEMENT,
  ASSESSMENTS_COMPLETED_PARENT_REQUEST_DELAY,
  ASSESSMENTS_COMPLETED_NON_PARENT_REQUEST_DELAY,
  PARENT_REQUEST_TO_DELAY,
];
export const PRE_SCHOOL_ALLOWED_REASON_IDS: number[] = [
  ASSESSMENTS_COMPLETED_PARENT_REQUEST_DELAY,
  ASSESSMENTS_COMPLETED_NON_PARENT_REQUEST_DELAY,
  PARENT_REQUEST_TO_DELAY,
  PARENTS_WITHDREW_REFERRAL,
  STUDENT_MOVED,
  STUDENT_DIED,
  DELAYS_CONTACTING_PARENTS,
  PARENTS_CANCELLED_EVAL,
  PARENTS_REFUSED_AVAILABILITY,
  STUDENT_HEALTH_UNAVAILABILITY,
  BILINGUAL_EVALUATOR_UNAVAILABLE,
  TRANSLATION_UNAVAILABLE,
  DELAY_SECURING_EVALUATOR,
  ADDITIONAL_ASSESSMENTS_DOE,
  EVALUATOR_SCHEDULING_DELAY,
  EVAL_TIMELINE_EXTENSION_AGREEMENT,
  EVAL_TIMELINE_BEGAN_EXTENSION_AGREEMENT,
];

export interface ReasonForm {
  reasonForDelayId: FormControl<string>;
  description: FormControl<string>;
  caseActionSk: FormControl<string>;
  stageId: FormControl<number>;
}
